export default [{
  path: '/year-end-w',
  name: 'year-end-w',
  meta: {
      title: "活动主页",
      requiresAuth: false,
  },
  component: () =>
      import (/* webpackChunkName: 'year-active' */'./year-active-web/index.vue')
},
{
    path: '/year-end-m',
    name: 'year-end-m',
    meta: {
        title: "活动主页",
        requiresAuth: false,
    },
    component: () =>
        import (/* webpackChunkName: 'year-active' */'./year-active-mobile/index.vue') 
  },


]